import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DivergenceItem {
  label: string;
  typed: string;
  returned: string;
  hasDivergence: boolean;
}

export interface DivergenceDialogData {
  items: DivergenceItem[];
}

@Component({
  selector: 'app-divergence-dialog',
  templateUrl: './divergence-dialog.component.html',
  styleUrls: ['./divergence-dialog.component.sass'],
})
export class DivergenceDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DivergenceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DivergenceDialogData
  ) {}
}
